import { createAsyncThunk } from "@reduxjs/toolkit";
import { APP_PATH } from "../../api/backendPath";
import axios from "axios";
import { toast } from "../../components/toast";

const getAuthHeader = () => ({
  Authorization: `Bearer ${sessionStorage.getItem("usr_1a2b3c")}`,
});

// Fetch services list
export const fetchImagingServices = createAsyncThunk(
  "imagingServices/fetchList",
  async (params = {}, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_API_URL + APP_PATH.imagingServices,
        { headers: getAuthHeader(), params },
      );
      return response.data?.data || { services: [], pagination: {} };
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

// Add new service
export const addImagingService = createAsyncThunk(
  "imagingServices/add",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        process.env.REACT_APP_API_URL + APP_PATH.imagingServices,
        payload,
        { headers: getAuthHeader() },
      );
      toast.success("Service added successfully");
      return response.data?.data;
    } catch (error) {
      const msg = error.response?.data?.message || "Failed to add service";
      toast.error(msg);
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

// Update existing service
export const updateImagingService = createAsyncThunk(
  "imagingServices/update",
  async ({ serviceId, ...payload }, { rejectWithValue }) => {
    try {
      const response = await axios.put(
        `${process.env.REACT_APP_API_URL}${APP_PATH.imagingServices}/${serviceId}`,
        payload,
        { headers: getAuthHeader() },
      );
      toast.success("Service updated successfully");
      return response.data?.data;
    } catch (error) {
      const msg = error.response?.data?.message || "Failed to update service";
      toast.error(msg);
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

// Delete (deactivate) service
export const deleteImagingService = createAsyncThunk(
  "imagingServices/delete",
  async (serviceId, { rejectWithValue }) => {
    try {
      await axios.delete(
        `${process.env.REACT_APP_API_URL}${APP_PATH.imagingServices}/${serviceId}`,
        { headers: getAuthHeader() },
      );
      toast.success("Service deactivated successfully");
      return serviceId;
    } catch (error) {
      const msg =
        error.response?.data?.message || "Failed to deactivate service";
      toast.error(msg);
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);
